export default "__VITE_ASSET__3141359d__"